:host {
  display: inline-block;
}

.hover-btn {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 1px 6px;
  min-height: 19px;
  max-height: 19px;
  height: fit-content;
  width: fit-content;
  font-family: var(--primary-font);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.7;
  text-decoration: none;
  text-transform: none;
  color: var(--color-nero);
  background-color: var(--color-bleached-silk);
  border-radius: 3px;
  cursor: pointer;

  @include breakpointMin('md') {
    min-height: 23px;
    max-height: 23px;
  }

  slot {
    display: none;
  }

  &.hover {
    lilu-icon {
      margin-right: 10px;
    }

    slot {
      display: inline;
    }
  }
}
